import i18n from "@config/i18n";

/**
 * Standard option label for the curricular key selectors (Campus, Department,
 * Modality, Shift, Program) and the Curriculum/Subject selectors in advanced
 * search: `code - name`.
 * Falls back to a localized "no name" text when the entity has no name.
 */
const getCurricularLabel = (code?: string | null, name?: string | null) => {
  const displayName = name?.trim() || i18n.t("advanced-search.selectors.no-name");

  return `${code} - ${displayName}`;
};

export default getCurricularLabel;
